import { APP_CONFIG } from './constants'

/**
 * Detectar si el usuario está en un dispositivo Android
 * @returns {boolean}
 */
export const isAndroid = () => {
  return /Android/i.test(navigator.userAgent)
}

/**
 * Detectar si es un dispositivo móvil
 * @returns {boolean}
 */
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

/**
 * Verificar si la aplicación está instalada (solo Android)
 * @param {string} packageName - Nombre del paquete de la app
 * @returns {Promise<boolean>}
 */
export const isAppInstalled = async (packageName = APP_CONFIG.PACKAGE_NAME) => {
  if (!isAndroid()) return false
    
  try {
    // Intentar abrir la app usando el intent scheme
    const intent = `intent://coronas#Intent;scheme=arca;package=${packageName};end`
    window.location.href = intent
        
    // Si llegamos aquí, probablemente la app no esté instalada
    return false
    //eslint-disable-next-line no-unused-vars
  } catch (error) {
    return false
  }
}

/**
 * Manejar el clic en "Comprar en App"
 * Evalúa si está en Android y si la app está instalada
 */
export const handleBuyInApp = async () => {
  if (isAndroid()) {
    try {
      // Intentar abrir la app directamente
      const intent = `intent://coronas#Intent;scheme=arca;package=${APP_CONFIG.PACKAGE_NAME};end`
      window.location.href = intent
            
      // Fallback: si no se abre la app, abrir Play Store después de un delay
      setTimeout(() => {
        window.open(APP_CONFIG.PLAY_STORE_URL, '_blank')
      }, 2000)
      //eslint-disable-next-line no-unused-vars
    } catch (error) {
      // Si hay error, ir directamente a Play Store
      window.open(APP_CONFIG.PLAY_STORE_URL, '_blank')
    }
  } else {
    // Si no es Android, ir a Play Store
    window.open(APP_CONFIG.PLAY_STORE_URL, '_blank')
  }
}

/**
 * Truncar texto a un número específico de palabras
 * @param {string} text - Texto a truncar
 * @param {number} maxWords - Número máximo de palabras
 * @returns {string}
 */
export const truncateText = (text, maxWords = 10) => {
  if (!text) return ''
    
  const words = text.split(' ')
  if (words.length <= maxWords) return text
    
  return words.slice(0, maxWords).join(' ') + '...'
}

/**
 * Generar slug a partir de un texto
 * @param {string} text - Texto a convertir
 * @returns {string}
 */
export const generateSlug = (text) => {
  if (!text) return ''
    
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Quitar acentos
    .replace(/[^a-z0-9\s-]/g, '') // Quitar caracteres especiales
    .replace(/\s+/g, '-') // Reemplazar espacios con guiones
    .replace(/-+/g, '-') // Reemplazar múltiples guiones con uno solo
    .trim('-')
}

/**
 * Scroll suave hacia un elemento
 * @param {string} elementId - ID del elemento
 */
export const scrollToElement = (elementId) => {
  const element = document.getElementById(elementId)
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }
}

/**
 * Validar si una URL de imagen es válida
 * @param {string} url - URL a validar
 * @returns {Promise<boolean>}
 */
export const isValidImageUrl = (url) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve(true)
    img.onerror = () => resolve(false)
    img.src = url
  })
}

/**
 * Obtener el primer color válido de una lista de colores
 * @param {Array} colors - Array de colores
 * @returns {string}
 */
export const getFirstValidColor = (colors) => {
  if (!Array.isArray(colors) || colors.length === 0) return 'N/A'
    
  const firstColor = colors[0]
  if (typeof firstColor[0] === 'object' && firstColor[0]?.color) {
    return colors.length > 1 ? firstColor[0].color + ' +' : firstColor[0].color
  }
    
  return firstColor || 'N/A'
}

/**
 * Formatear array de colores para mostrar
 * @param {Array} colors - Array de colores
 * @returns {string}
 */
export const formatColorsDisplay = (colors) => {
  if (!Array.isArray(colors) || colors.length === 0) return 'N/A'
    
  const firstColor = getFirstValidColor(colors)
    
  return firstColor
}